import AddMultipleSimpleProducts from './AddMultipleSimpleProducts.graphql';
import AddConfigurableProduct from './AddConfigurableProduct.graphql';

export { AddMultipleSimpleProducts, AddConfigurableProduct };
export default {};
